import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { transformSchoolLevel } from '@backrs_ui/grow-ui/src/components/MarkersOfSuccess/markersOfSuccess.util';
import { CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { postAPISurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/thunks/userResponse.thunk';
import {
  addUserQuestionResponse,
  selectUserResponseSet,
} from '@backrs_ui/grow-ui/src/redux/userResponse/userResponse';

import { Box, SxProps, Theme } from '@mui/system';
import { TailSpin } from 'react-loader-spinner';

import { SurveyPage } from './SurveyPage';

export const SurveyPageContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { school_level } = useAppSelector((state) => state.userResponseSet.userResponseSet);

  const careerQuestions = useAppSelector((state) => state.survey.careerQuestions);

  const { careerPaths, careerPathRoles, careerPathMeanings, careerPathEnjoyments } = useAppSelector(
    (state) => state.careerPath,
  );

  const userResponseSet: CareerUserResponseSet = useSelector((state: RootState) =>
    selectUserResponseSet(state),
  );

  const handleFinishSurvey = async () => {
    // even for unauthenticated users, we call the thunk as it calculates the career path suggestions. We just wont post to the BE since there is no access token
    const resultAction = await dispatch(
      postAPISurveyResults({
        userResponseSet,
        careerQuestions,
        careerPaths,
        careerPathRoles,
        careerPathMeanings,
        careerPathEnjoyments,
      }),
    );

    if (postAPISurveyResults.fulfilled.match(resultAction)) {
      navigate(APP_ROUTE.GENERATING_BLUEPRINT);

      return;
    }

    if (postAPISurveyResults.rejected.match(resultAction)) {
      console.error(resultAction.payload);
    }
  };

  /** if the user selected 'trade' or 'no_current_enrollment', we use 'college' as the key. If the user selected 'high_school', we use 'high_school' */
  const workingSchoolLevel = transformSchoolLevel(school_level);

  const onlyCareerQuestionsForSchoolLevel = careerQuestions.filter((question) =>
    ['both', workingSchoolLevel].includes(question.school_level),
  );

  if (!onlyCareerQuestionsForSchoolLevel.length) {
    return (
      <Box sx={loadingSpinnerStyle}>
        <TailSpin color="#000" height={50} width={50} />
      </Box>
    );
  }

  return (
    <SurveyPage
      careerQuestions={onlyCareerQuestionsForSchoolLevel}
      userResponseSet={userResponseSet}
      addUserQuestionResponse={(response) => dispatch(addUserQuestionResponse(response))}
      onFinishSurvey={handleFinishSurvey}
    />
  );
};

const loadingSpinnerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
} as const;
